/**
 * Represents the different mutation types in a Mutation Observer
 * https://developer.mozilla.org/en-US/docs/Web/API/MutationObserverInit
 */
var MutationType;
(function (MutationType) {
    MutationType["attributes"] = "attributes";
    MutationType["attributeFilter"] = "attributeFilter";
    MutationType["attributeOldValue"] = "attributeOldValue";
    MutationType["characterData"] = "characterData";
    MutationType["characterDataOldValue"] = "characterDataOldValue";
    MutationType["childList"] = "childList";
    MutationType["subtree"] = "subtree";
})(MutationType || (MutationType = {}));

export { MutationType };
//# sourceMappingURL=mutation-type.js.map
